import { render, staticRenderFns } from "./TaskListTemplates.vue?vue&type=template&id=45592ca4&scoped=true&"
import script from "./TaskListTemplates.vue?vue&type=script&lang=js&"
export * from "./TaskListTemplates.vue?vue&type=script&lang=js&"
import style0 from "./TaskListTemplates.vue?vue&type=style&index=0&id=45592ca4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45592ca4",
  null
  
)

export default component.exports